import { Box, Card, CardMedia, Stack, Typography } from "@mui/material"
import { DamsAppAsset } from "../../assets/registry"
import { ContainedButton, OutlinedButton } from "../../components/Button/AppButton"
import { DamsColors } from "../../components/styles/DamsColors"
import { DamsEmptyPageProps } from ".";



function NoItemContent({
    type,
    title = '',
    subtitle = '',
    addItemBtn,
    clearSearchBtn
}:
    Readonly<{
        type?: DamsEmptyPageProps | string,
        title?: string,
        subtitle?: string,
        addItemBtn?: () => void,
        clearSearchBtn?: () => void
    }>
): JSX.Element {

    const card_style = type === 'empty-search' && { width: 320, height: 243 };
    const card_icon = type === 'empty-db'
        ? DamsAppAsset.image.empty_db
        : DamsAppAsset.image.empty_search;

    return (
        <Stack rowGap={3} alignItems={'center'}>
            <Card
                elevation={0}
                sx={{ ...styles.cardContainer, ...card_style }}>

                <CardMedia
                    component="img"
                    alt="No Db Item"
                    image={card_icon}
                    title="Descriptive Title"
                    height={'100%'}
                    width={'100%'}
                />
            </Card>

            <Stack
                width={512}
                direction={'column'}
                alignItems={'center'}
                gap={2}
            >
                <Box>
                    {/* info title  */}
                    <Typography
                        fontFamily={'Inter'}
                        fontSize={16}
                        fontWeight={500}
                        color={DamsColors.Text.PrimaryText}
                        textAlign={'center'}
                    >
                        {title}
                    </Typography>

                    {/* info Subtitle  */}
                    <Typography
                        fontFamily={'Inter'}
                        fontSize={14}
                        fontWeight={500}
                        color={DamsColors.Text.SecondaryText}
                        textAlign={'center'}
                        width={400}
                    >
                        {subtitle}
                    </Typography>
                </Box>

                <Box display={'flex'} gap={2}>

                    {type === 'empty-search' && (
                        <OutlinedButton
                            height={40}
                            width={122}
                            title="Clear Search"
                            onClick={() => {
                                if (clearSearchBtn !== undefined) {
                                    clearSearchBtn()
                                }
                            }}
                        />
                    )}


                    <ContainedButton
                        height={40}
                        width={122}
                        title="Add New"
                        btnIconSrc={DamsAppAsset.icons.plus_white}
                        onClick={() => {
                            if (addItemBtn !== undefined) {
                                addItemBtn()
                            }
                        }}
                    />
                </Box>
            </Stack>
        </Stack>
    )
}


const styles = {
    cardContainer: {
        height: 360,
        width: 402,
    },
}

export { NoItemContent }

